<template>
  <div class="hnrkr-main">
    <div class="go-back">
      <van-button @click="goBack" size="small" color="#FF7B4E"><van-icon name="arrow-left" /> 返回</van-button>
    </div>
    <div class="hnrk-header">
    </div>
    <div class="hnrk-tab">
      <div>
        <div :class="['default', type==1?'selected':'']" @click="goType(1)">跑步里程碑</div>
      </div>
      <div>
        <div :class="['default', type==2?'selected':'']" @click="goType(2)">获奖名单</div>
      </div>

    </div>
    <div class="hnrk-body">
      <template v-if="type==1">
        <RankList  v-bind:itemid="item_sub_id"></RankList>
      </template>
      <template v-else>
        <div class="other"><img src="https://oss.mcloud.moveclub.cn/mpms/20210802/1627888349-61079addd8201.png" alt="" style="width: 100%;height: 100%;"></div>
      </template>
    </div>
    <van-overlay z-index="1000" :show="show" @click="show = false">
      <div class="wrapper">
        <img style="width:100%" src="../../../assets/img/common/share.png" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import "./Index.less";
import RankList from './components/RankList'
import {mapMutations} from "vuex";
import moment from "moment";
import {Button, Overlay, Search} from 'vant'

export default {
  name: "Index",
  props: ["item_sub_id", "sports_id"],
  data() {
    return {
      show: false,
      detail: "",
      itemDetail: "",
      joinList: [],
      type: 1,
      keyword: ''
    };
  },
  components: {
    vanSearch:Search,
    VanOverlay: Overlay,
    RankList,
    VanButton:Button
  },
  methods: {
    ...mapMutations(["toggleShowFill"]),
    goBack() {
      this.$router.back(-1)
    },
    goType(type){
      this.type = type
    },
    goVote(val){
      this.$router.push({name:'vote',params:{vcid:val.vcid, today_state:this.today_state}})
    },
    goVideo(item) {
      this.$router.push({name:'video',params:{mediaurl:item.mediaurl,imgurl:item.imgurl}})
    },
    goto() {
      if(this.detail.today_state == 0){
        this.$router.push({name:'bn_join', params:this.$route.params})
      }else{
        this.$toast('今日您已上传了,请不要重复上传');
      }

    },
    init: function () {
      this.$toast.loading({
        duration: 0,
      });
      let params = { cpgid: this.item_sub_id };
      Promise.all([
        this.$api.sports.sportsMain(this.sports_id),
        this.$api.sports.getComparegame(params),
        this.$api.bainian.userState()
      ]).then(
          (res) => {
            let { bgstyle, id, tabstyle, introstyle, title } = res[0].data;
            try {
              bgstyle = JSON.parse(bgstyle);
              tabstyle = JSON.parse(tabstyle);
              introstyle = JSON.parse(introstyle);
            } catch (e) {
              console.error(e);
            }
            this.detail = res[2].data;
            this.joinList = Object.assign([], res[1]["data"]["list"]);
            delete res[1]["data"]["list"];
            let { start_time, end_time, sex_limit, age_limit,vote_start_time } = res[1]["data"];
            start_time = moment(start_time).valueOf();
            end_time = moment(vote_start_time).valueOf() - 1000;
            var sys_time = res[1]["sys_time"] * 1000;
            let tips,
                disabled = true;
            if (sys_time < start_time) {
              tips = "活动未开始";
            } else if (sys_time > end_time) {
              tips = "活动已结束";
            } else {
              tips = "上传照片";
              disabled = false;
            }
            let starttime = moment(start_time).format('MM月DD日')
            let endtime = moment(end_time).format('MM月DD日')
            this.itemDetail = Object.assign(res[1]["data"], { tips, disabled,starttime,endtime });
            this.$toast.clear();
            //判断 是否需要 限制性别 或生日 如果需要则要填写信息
            if (+sex_limit !== 0 || +age_limit !== 0) {
              let { name, phone, id_number } = this.getOnlyUserInfo;

              console.log(name);
              console.log(phone);
              console.log(id_number);

              if (!!name && !!phone && !!id_number) {
              } else {
                //需要补全信息
                this.toggleShowFill(true);
                return;
              }
            }
          },
          () => {
            this.$toast.clear();
          }
      ).then(() => {
        const shareConf = {
          title: ` 我正在参加“嘉定区建党100周年主题健康跑”。动动手指，请帮我投一票吧！`,
          path: '/pages/webview/index?src=' + encodeURIComponent(window.location.href),
        }

        wx.miniProgram.postMessage({ data: JSON.stringify(shareConf) })
      })
    },
  },
  mounted() {
    this.init();
  }
}
</script>

<style scoped>

</style>
